import { ReactNode } from "react";
import { FCX } from "@datassential/platform-ui-lib";
import { BsStars } from "react-icons/bs";
import cn from "classnames";

const AiResultQuestion: FCX<{ question: ReactNode }> = ({
    question,
    className,
    testId,
}) => {
    return (
        <div
            className={cn(
                "AiResultQuestion",
                className
            )}
            data-testid={testId ?? "blockAiResultQuestion"}
        >
            <BsStars
                className="AiResultQuestion__icon"
                data-testid="iconAiResultQuestion"
            />
            <span
                className="AiResultQuestion__label"
                data-testid="textAiResultQuestionLabel"
            >AI Generated Answer For:</span>
            <span
                className="AiResultQuestion__text"
                data-testid="textAiResultQuestion"
            >{question}</span>
        </div>
    );
};

export default AiResultQuestion;